<div *ngIf="user" class="wrap-box">
  <div class="cover-picture-box">
    <div class="cover-picture">
      <img class="CP" src="http://localhost:9091/User/{{ user.coverImage }}" alt="Photo de Couverture" />
    </div>
  </div>
  <img src="http://localhost:9091/User/{{ user.profileImage }}" alt="Photo de profile" class="profile-picture" alt="Profile-picture"/>
  <h3>{{ user.nom }} {{ user.prenom }}</h3>
  

  <ul class="nav-list">
    <li class="nav-item"><a routerLink="/home/profile/pub">Posts</a>    </li>
   
    <li class="nav-item"><a href="#">Events</a></li>
    <li class="nav-item"><a href="#">Rating</a></li>
    
  </ul>
  <div>
    <router-outlet></router-outlet>
  </div>
</div>


